var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeakericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.32812 6.3335V23.6668C4.32813 23.8221 4.36678 23.9752 4.44102 24.114C4.51526 24.2529 4.62306 24.3737 4.75587 24.4668C4.88868 24.56 5.04285 24.6229 5.20619 24.6507C5.36952 24.6785 5.53753 24.6703 5.6969 24.6268L29.2227 18.2102C29.4448 18.1496 29.6399 18.0233 29.7788 17.8502C29.9176 17.6771 29.9926 17.4665 29.9926 17.2502V12.7502C29.9926 12.5338 29.9176 12.3233 29.7788 12.1502C29.6399 11.9771 29.4448 11.8507 29.2227 11.7902L5.6969 5.3735C5.53753 5.33003 5.36952 5.32186 5.20619 5.34963C5.04285 5.3774 4.88868 5.44035 4.75587 5.5335C4.62306 5.62664 4.51526 5.74743 4.44102 5.88628C4.36678 6.02514 4.32812 6.17825 4.32812 6.3335V6.3335Z",
    stroke: "#20996B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6466 19.4578V23.9996C24.6466 24.2648 24.5339 24.5192 24.3334 24.7067C24.1328 24.8943 23.8609 24.9996 23.5772 24.9996H19.2998C19.0162 24.9996 18.7442 24.8943 18.5437 24.7067C18.3431 24.5192 18.2305 24.2648 18.2305 23.9996V8.7915",
    stroke: "#20996B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakericon);
export default __webpack_public_path__ + "static/media/speakericon.331ad6299fb3f7b2839d711bccb3d805.svg";
export { ForwardRef as ReactComponent };